// extracted by mini-css-extract-plugin
export default {"reasonsContainer":"PurposeOfTraining_reasonsContainer__KooRY","header":"PurposeOfTraining_header__-TzOb","noReasons":"PurposeOfTraining_noReasons__sJcMM"};